export default {
	Title: 'Tổng quan',
	TitleProcess: 'Quy trình',
	InstructionsForUse: 'Hướng dẫn sử dụng',
	MeInvIntruction: 'Hướng dẫn sử dụng MISA meInvoice',
	VideoIntruction: 'Xem phim hướng dẫn',
	DocsIntruction: 'Xem bài viết hướng dẫn',
	AvaDashboard: 'Trợ lý AI',
	SearchEmpty: 'Không tìm thấy thông tin theo điều kiện tìm kiếm, vui lòng thử lại',
	AvaGreeting: 'Xin chào! AVA có thể giúp gì cho bạn hôm nay?',
	AvaIntroDescription: 'Công cụ AI giúp tăng tốc, nâng cao hiệu suất công việc của bạn',
	AvaIntroExplore: 'Hãy cùng MISA AVA khám phá các tính năng AI nổi bật',
	AvaFeatures: {
		SupportSoftware: 'Hỗ trợ sử dụng phần mềm',
		CommunityQA: 'Hỏi đáp cùng cộng đồng MISA trên sản phẩm',
		LegalLookup: 'Tra cứu văn bản pháp luật',
		QuickReport: 'Xem nhanh số liệu báo cáo',
		TestResult: 'Giải thích kết quả kiểm tra',
		CheckVat: 'Kiểm tra thuế suất HHDV',
		CostType: 'Tự động phân loại chi phí',
		CheckBusiness: 'Kiểm tra ngành nghề kinh doanh',
		ReadEmail: 'Dịch nội dung email',
		ReadInvoice: 'Đọc hóa đơn NCC nước ngoài',
		WatchingFilms: 'Xem phim'
	},
	AvaFeaturesDesc: {
		TestResult: 'Giải thích kết quả kiểm tra hóa đơn đầu vào, tham chiếu quy định liên quan và hướng dẫn xử lý',
		CheckVat: 'Kiểm tra thuế suất với những dòng hàng hóa có tính chất Hàng hóa, dịch vụ trên hóa đơn',
		CostType: 'Tự động phân loại hóa đơn theo chi phí, kiểm tra và cảnh báo hóa đơn vượt định mức',
		CheckBusiness: 'Tự động kiểm tra hóa đơn có hàng hóa không phù hợp với ngành nghề kinh doanh của người bán',
		ReadEmail: 'Gửi email phản hồi kết quả kiểm tra hóa đơn cho nhà cung cấp bằng tiếng nước ngoài',
		ReadInvoice: 'Đọc hóa đơn đặc thù từ nhà cung cấp nước ngoài (Google, Zoom, Meta, Tiktok,…)'
	},
	HideLess: 'Ẩn bớt',
	ShowMore: 'Xem thêm',
	BuyNow: 'Mua ngay',
	Dashboard: {
		Extend: 'Gia hạn',
		BuyMore: 'Mua thêm',
		LicenseOrderNo: 'Tài nguyên mua đơn hàng số ',
		ApprovedStatus: ' đang trạng thái chờ duyệt ',
		ViewOrder: 'Xem đơn hàng',
		TotalInvoiceProcess: 'Hóa đơn đã xử lý',
		InvoiceUncheck: 'Hóa đơn không kiểm tra',
		BeforeVatAmount: 'Trước thuế GTGT',
		VatAmount: 'Thuế GTGT',
		TotalAmount: 'Tổng tiền TT',
		ViewDetail: 'Xem chi tiết',
		InvoiceValid: 'Hóa đơn hợp lệ',
		InvoiceInValid: 'Hóa đơn không hợp lệ',
		SituationReceiveInvoice: 'Tình hình nhận hóa đơn theo thời gian',
		InvoiceNo: 'Số hóa đơn',
		TotalValueAmount: 'Tổng giá trị hóa đơn',
		NotData: 'Chưa phát sinh dữ liệu',
		LicenseInfo: 'Thông tin tài nguyên',
		InvoiceBought: 'Hóa đơn đã mua',
		InvoiceUsed: 'Hóa đơn đã sử dụng',
		InvoiceNotUse: 'Hóa đơn chưa sử dụng',
		UseDate: 'Thời hạn sử dụng đến',
		AutoConnectSupplier: 'Tự động kết nối NCC',
		AutoConnectPrefix: 'Tự động ',
		AutoConnectHighlight: 'KẾT NỐI',
		AutoConnectSuffix: ' nhà cung cấp',
		MessageConnect:
			'MISA meInvoice đã kết nối với nhà cung cấp giúp tự động lấy về hóa đơn để tiết kiệm hơn 80% thời gian nhập liệu và xử lý hóa đơn.',
		ConnectNow: 'Kết nối ngay',
		CycCodeVND: 'VND',
		Currentcy: 'Ngoại tệ',
		TooltiptotalAmountWithoutVat: 'Trước thuế giá trị gia tăng',
		TooltiptotalVatAmount: 'Thuế giá trị gia tăng',
		TooltiptotalAmount: 'Tổng tiền thanh toán',
		Invoice: 'hóa đơn',
		Million: 'triệu',
		Thousand: 'nghìn',
		Up: 'Tăng',
		Down: 'Giảm',
		PercentPeriod: '% so với kỳ trước',
		Organizations: 'Các chi nhánh - phòng ban khác',
		SuppliersOther: 'Các nhà cung cấp khác',
		NumberInvoice: 'Số lượng hóa đơn',
		TotalAmount1: 'Tổng tiền thanh toán',

		//NVNAM3: 1/5/2023
		SelectTime: 'Chọn thời gian',
		FromDate: 'Từ ngày',
		ToDate: 'Đến ngày',
		Fee: 'Phí, lệ phí',
		OtherDeductions: 'Giảm trừ khác',
		//màn hình quy trình nghiệp vụ
		CreatedEmail: 'Tạo email nhận hóa đơn',
		UploadInovice: 'Tải hóa đơn',
		EmailResponse: 'Nhận email hóa đơn',
		ConnectTaxixaxion: 'Kết nối cơ quan thuế',
		ConnectSupplier: 'Kết nối nhà cung cấp',
		OrganizationUnit: 'Cơ cấu tổ chức',
		CheckInvoice: 'Xử lý, kiểm tra hóa đơn',
		TitleInvalid: 'Không hợp lệ',
		TitleValid: 'Hợp lệ',
		SupplierRespone: 'Phản hồi nhà cung cấp',
		ThirdPartyRespone: 'Phản hồi cho bên thứ 3',
		ExportExcel: 'Xuất khẩu',
		SyncMAKT: 'Đồng bộ vào <br /> phần mềm kế toán',
		LastTimeGetData: 'Cập nhật đến {time}',
		TooltipTotalReductionAmount:
			'Là tổng tiền hàng đã trừ đi tiền chiết khấu (áp dụng cho mọi loại hóa đơn), đồng thời trừ thêm phần tiền thuế được giảm trong trường hợp hóa đơn là hóa đơn bán hàng giảm thuế.'
	},
	Intructions: {
		Complete: 'Hoàn thành:',
		Title: name => `Xin chào, ${name}`,
		SubTitle:
			'Để có thể bắt đầu sử dụng phần mềm MISA meInvoice - Xử lý hóa đơn, bạn vui lòng thực hiện theo các bước sau',
		TitleStep: 'Bắt đầu sử dụng',
		NoVideo: 'Video đang trong quá trình xây dựng',
		Step1: {
			Title: 'Giới thiệu tổng quan',
			SubTitle: 'Tổng quan về phần mềm Xử lý hóa đơn',
			Childs1: 'Giới thiệu tổng quan'
		},
		Step2: {
			Title: 'Tạo email nhận hóa đơn',
			SubTitle: 'Tạo email để nhận hóa đơn từ phần mềm',
			Childs1: 'Tạo email nhận hóa đơn'
		},
		Step3: {
			Title: 'Đưa hóa đơn vào phần mềm',
			SubTitle: 'Các hình thức đưa hóa đơn vào phần mềm',
			Childs1: 'Tải lên hóa đơn',
			Childs2: email => `Gửi hoặc chuyển tiếp hóa đơn điện tử đến email ${email}`,
			Childs3: 'Kết nối với Cơ quan Thuế để tự động tải hóa đơn',
			Childs4: 'Kết nối với nhà cung cấp để tự động tải hóa đơn'
		},
		Step4: {
			Title: 'Xử lý, kiểm tra tính hợp lệ của hóa đơn',
			SubTitle: 'Giải thích cách xử lý, kiểm tra tính hợp lệ của hóa đơn',
			Childs1: 'Xử lý, kiểm tra tính hợp lệ của hóa đơn'
		},
		Step5: {
			Title: 'Các thiết lập khác',
			SubTitle: 'Thiết lập cơ cấu tổ chức hoặc tùy chọn các thiết lập khác',
			Childs1: 'Cơ cấu tổ chức',
			Childs2: 'Thiết lập tùy chọn'
		},
		Step6: {
			Title: 'Xem báo cáo',
			SubTitle: 'Xem các báo cáo chi tiết và tổng hợp về tình hình sử dụng hóa đơn của đơn vị',
			Childs1: 'Bảng kê hóa đơn hàng hóa, dịch vụ mua vào (tổng hợp)',
			Childs2: 'Bảng kê hóa đơn hàng hóa, dịch vụ mua vào (chi tiết)',
			Childs3: 'Báo cáo hóa đơn rủi ro theo nhà cung cấp',
			Childs4: 'Báo cáo hóa đơn theo tình trạng hoạt động của nhà cung cấp',
			Childs5: 'Báo cáo hóa đơn thay thế, điều chỉnh',
			Childs6: 'Báo cáo thống kê chi phí theo nhãn dán',
			Childs7: 'Báo cáo tổng hợp chi phí'
		},
		Step7: {
			Title: 'Kết nối với phần mềm kế toán',
			SubTitle: 'Kết nối với phần mềm kế toán để tải về hóa đơn',
			Childs1: 'Kết nối AMIS kế toán',
			Childs2: 'Kết nối MISA SME',
			Childs3: 'Kết nối ASP',
			Childs4: 'Kết nối Mimosa online',
			Childs5: 'Kết nối Bamboo online'
		}
	},
	IntructionsGuide: {
		FilmGuide: 'Phim hướng dẫn sử dụng phần mềm',
		TotalFilmSubSystem: total => `${total} phim ở tất cả các phân hệ`,
		FilmSeem: (filmSeem, totalFile) => `Đã xem ${filmSeem}/${totalFile} video`,
		ChannelsSupport: 'Kênh hỗ trợ phần mềm',
		AvaChannel: 'Chat với trợ lý số MISA AVA',
		SupportAllTime: 'Giải đáp mọi thắc mắc về sản phẩm, thao tác nhanh các chức năng và xem báo cáo tức thời.',
		RegisterWithTeacherMISA: 'Đăng ký học với giảng viên MISA',
		RegisterNow: 'Đăng ký ngay',
		FilmGuideMISAMeinvoice: 'Phim hướng dẫn sử dụng MISA meInvoice',
		HeaderText: 'Vui lòng xem và thực hành theo các phim hướng dẫn để bạn có thể hiểu cơ bản cách sử dụng phần mềm',
		PlaceHoder: 'Nhập tên phim để tìm kiếm',
		Unviewed: 'Chưa xem',
		Viewed: 'Đã xem',
		All: 'Tất cả',
		OverView: 'Giới thiệu tổng quan',
		CreateEmailToReceiveInvoices: 'Tạo email nhận hóa đơn',
		AddInvoicesToTheSoftware: 'Đưa hóa đơn vào phần mềm',
		ProcessCheckTheValidityOfTheInvoice: 'Xử lý, kiểm tra tính hợp lệ của hóa đơn',
		OtherSettings: 'Các thiết lập khác',
		ViewReport: 'Xem báo cáo',
		ConnectToAccountingSoftware: 'Kết nối với phần mềm kế toán',
		ZoomIn: 'Phóng to',
		ZoomOut: 'Thu nhỏ'
	},
	ToolbarGuide: {
		Step1Title: 'Chọn đơn vị làm việc',
		Step1Content: 'Nhấn để chọn đơn vị làm việc của bạn.',
		Step2Title: 'Email nhận hóa đơn',
		Step2Content:
			'Gửi hoặc chuyển tiếp (forward) email hóa đơn đến địa chỉ này để hệ thống tự động xử lý. Bạn có thể nhấn vào email để sao chép nhanh chóng.',
		Step3Title: 'Thiết lập hệ thống',
		Step3Content:
			'Bao gồm các thiết lập trong hệ thống như: Tùy chọn, Quản lý người dùng, Vai trò quyền hạn, Quản lý tài nguyên, Nhật ký truy cập,...',
		Step4Title: 'Bắt đầu sử dụng',
		Step4Content: 'Hướng dẫn sử dụng MISA meInvoice - Xử lý hóa đơn.'
	}
};
